import { render, staticRenderFns } from "./reportes.vue?vue&type=template&id=06c060c8"
import script from "./reportes.vue?vue&type=script&lang=js"
export * from "./reportes.vue?vue&type=script&lang=js"
import style0 from "./reportes.vue?vue&type=style&index=0&id=06c060c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports